module.exports = __webpack_public_path__ + "static/media/diploma1.a3fa69dd.png";